import React from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm700, warm500, stone, textMuted } from './tokens'

type Props = { l: Translation['landing']['shipping'] }

export const EnviosSection: React.FC<Props> = ({ l }) => (
  <section id="envios" className="px-10 md:px-20 py-20" style={{ background: stone }}>
    <p className="flex items-center gap-3 text-[0.75rem] font-medium tracking-[0.18em] uppercase mb-4" style={{ color: warm500 }}>
      <span className="w-6 h-px inline-block" style={{ background: warm500 }} />
      {l.sectionLabel}
    </p>
    <h2
      className="text-[clamp(2rem,3.5vw,3rem)] font-light leading-[1.15] mb-8"
      style={{ fontFamily: serif, color: warm900 }}
    >
      {l.title}<br />
      <em className="italic" style={{ color: warm500 }}>{l.titleEm}</em>
    </h2>
    <h3 className="font-semibold text-[1.2rem] mb-4" style={{ fontFamily: serif, color: warm700 }}>{l.subTitle}</h3>
    <div className="overflow-x-auto">
      <table className="w-full border-collapse bg-white rounded-[2px] overflow-hidden text-left" style={{ minWidth: '540px' }}>
        <thead>
          <tr>
            {([l.th.dest, l.th.time] as const).map(h => (
              <th key={h} className="py-3.5 px-5 text-[0.72rem] font-medium tracking-[0.12em] uppercase" style={{ background: warm900, color: '#f5ece0' }}>{h}</th>
            ))}
            {([l.th.halfDozen, l.th.dozen, l.th.giftBox] as const).map(h => (
              <th key={h} className="py-3.5 px-5 text-[0.72rem] font-medium tracking-[0.12em] uppercase text-right" style={{ background: warm900, color: '#f5ece0' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {l.rows.map((row, i) => (
            <tr key={i} className={`border-b last:border-0 hover:bg-[#fdf8f2] transition-colors${i % 2 === 0 ? ' bg-[#fdf8f2]' : ' bg-white'}`} style={{ borderColor: stone }}>
              <td className="py-3.5 px-5 text-[0.88rem]" style={{ color: '#2a1f0e' }}><span className="mr-1">{row.flag}</span>{row.dest}</td>
              <td className="py-3.5 px-5 text-[0.88rem]" style={{ color: '#2a1f0e' }}>{row.time}</td>
              <td className="py-3.5 px-5 text-[0.88rem] text-right" style={{ color: '#2a1f0e' }}>{row.halfDozen}</td>
              <td className="py-3.5 px-5 text-[0.88rem] text-right" style={{ color: '#2a1f0e' }}>{row.dozen}</td>
              <td className="py-3.5 px-5 text-[0.88rem] text-right" style={{ color: '#2a1f0e' }}>{row.giftBox}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="text-[0.8rem] mt-4 italic" style={{ color: textMuted }}>{l.footnote}</p>
    <h3 className="font-semibold text-[1.2rem] mt-10 mb-4" style={{ fontFamily: serif, color: warm700 }}>{l.infoTitle}</h3>
    <ul className="flex flex-col gap-2 pl-5 list-disc">
      {l.infoItems.map((item, i) => (
        <li key={i} className="text-[0.88rem] leading-[1.6]" style={{ color: textMuted }}>{item}</li>
      ))}
    </ul>
  </section>
)
